export default "__VITE_ASSET__Dq5vY2nz__"